export default __webpack_public_path__ + "static/media/apple.be3495ae.svg";